import {
    Box,
    Skeleton,
    VStack,
} from '@chakra-ui/react';
import React from 'react';
import { ReportedFindingDataMachine } from '@acp/shared';
import { ReportedFindingsMachineContext } from '../../machine/context';
import { ReportedFindingsWizardRowHeader, ReportedFindingsWizardRow } from './reported-findings-wizard-row';

export function ReportedFindingsWizardSkeleton({
    pageSize = 5,
}: {
    pageSize?: number;
}) {
    return (
        <VStack spacing={4} w="100%" alignItems="stretch">
            {new Array(pageSize).fill(0).map((_, idx) => (
                // eslint-disable-next-line react/no-array-index-key
                <Skeleton key={idx}>
                    <Box w="full" h="100px" />
                </Skeleton>
            ))}
        </VStack>
    );
}

export function ReportedFindingsWizardTable({
    children,
    rowGridWrapper,
}: {
    children?: (reportedFinding: ReportedFindingDataMachine) => React.ReactNode;
    rowGridWrapper?: React.ComponentType<{ children: React.ReactNode }>;
}) {
    const reportedFindings = ReportedFindingsMachineContext.useSelector(
        (state) => state.context.reportedFindings
    );
    return (
        <VStack alignItems="flex-start" spacing={4} mt={8}>
            <Box w="full">
                <ReportedFindingsWizardRowHeader />
            </Box>

            {reportedFindings == null && (<ReportedFindingsWizardSkeleton />)}

            <VStack spacing={4} w="full">
                {reportedFindings?.map((item) => (
                    <ReportedFindingsWizardRow
                        key={`${item.problemRegister.problemRegisterId}`}
                        reportedFinding={item}
                        gridWrapper={rowGridWrapper}
                    >
                        {children?.(item)}
                    </ReportedFindingsWizardRow>
                ))}
            </VStack>
        </VStack>
    );
}
